import React, { useState } from "react";
import { CheckIcon, CopyIcon } from "../../icons";

type CopyToClipboardProps = {
  textToCopy: string;
  className?: string;
};
const CopyToClipboard = ({ textToCopy, className = "" }: CopyToClipboardProps) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const copyToClipboard = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    event.preventDefault();
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 2000);
      });
    }
  };

  return (
    <div className={`flex items-center m-0 ${className}`}>
      {document.queryCommandSupported("copy") && (
        <button
          onClick={copyToClipboard}
          className="pr-2 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none"
        >
          {showSuccess ? <CheckIcon className="h-4 w-4" /> : <CopyIcon className="h-4 w-4" />}
        </button>
      )}
    </div>
  );
};

export default CopyToClipboard;
